import React from 'react';

export const About = () => (
  <div>
    <p className="mb-5 text-color-(--foreground) leading-relaxed">
      Nudge is built and maintained by the{' '}
      <a
        href="http://policylab.hks.harvard.edu"
        rel="noopener noreferrer"
        target="_blank"
        className="text-primary underline underline-offset-2 hover:text-primary/80 transition-colors"
      >
        Computational Policy Lab
      </a>
      .
    </p>
    <p className="mb-5 text-color-(--foreground) leading-relaxed">
      For questions, feedback, and bug reports, please reach out to us by email
      at{' '}
      <a
        href="mailto:nudge-help@lists.stanford.edu"
        rel="noopener noreferrer"
        target="_blank"
        className="text-primary underline underline-offset-2 hover:text-primary/80 transition-colors"
      >
        nudge-help@lists.stanford.edu
      </a>
      .
    </p>
    <p className="mb-5 text-color-(--foreground) leading-relaxed">
      The primary purpose of Nudge is to offer automated reminders to clients
      about court dates, in order to reduce failures-to-appear. We offer this
      web interface to supplement those reminders with additional manual
      messages, as necessary.
    </p>
    <p className="text-color-(--foreground) leading-relaxed">
      All messages sent through Nudge are delivered through the same phone
      number, which helps streamline the experience of the clients and limit
      confusion.
    </p>
  </div>
);
